import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { Outlet, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { MastersDetailSearch, MastersImportDataGrid } from '../components';
import FiltersLayoutHandler from '../components/FiltersLayoutHandler';
import { dateResponseMap } from '../helpers';
import { mastersStatusKeys } from '../types';
import {
  changeMastersImportFilterCountry,
  changeMastersImportFilterStartImportDate,
  changeMastersImportFilterEndImportDate,
  changeMastersImportFilterState,
  findMastersImportRequested,
  reportMastersImportLoadingSelector,
} from '../state';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '.MuiToolbar-root': {
    marginTop: theme.spacing(3),
  },
}));

const MastersImport = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const importDate = dateResponseMap(searchParams.get(mastersStatusKeys.importDate)) as Date;
  const state = searchParams.get(mastersStatusKeys.status);

  useEffect(() => {
    if (state) {
      dispatch(changeMastersImportFilterCountry([]));
      dispatch(changeMastersImportFilterStartImportDate(importDate));
      dispatch(changeMastersImportFilterEndImportDate(importDate));
      dispatch(changeMastersImportFilterState([state]));
      dispatch(findMastersImportRequested());
    }
  }, [dispatch, state]);

  return (
    <Container>
      <FiltersLayoutHandler selector={reportMastersImportLoadingSelector}>
        <MastersDetailSearch />
      </FiltersLayoutHandler>
      <MastersImportDataGrid />
      <Outlet />
    </Container>
  );
};

export default MastersImport;
